export default {
    watch: {
        'cart': {
            handler (newData, oldData) {
                let discountArr = this.$data.discountArr;
                let treatments = Array.from(new Set(discountArr.map(o => o.treatment.id)));
                this.updatePrice();
                this.clearDiscount();
                this.$data.discountAmount = 0;
                for(let i = 0; i < treatments.length; i++) {
                    let coupons = 0;
                    for (let j = 0; j < this.$data.cart.length; j++) {
                        if(this.$data.cart[j].id == treatments[i]){
                            coupons += this.$data.cart[j].quantity;
                        }
                    }
                    for(let k = 0; k < discountArr.length; k++) {
                        if(discountArr[k].treatment_id == treatments[i] && !this.discountExists(discountArr[k])) {
                            if(discountArr[k].is_coupon_limit) {
                                if(discountArr[k].amount <= coupons && !discountArr[k].is_percentage && !discountArr[k].is_sum) {
                                    this.$data.currDiscount.push(discountArr[k]);
                                    this.$data.freeCoupons.push(discountArr[k]);
                                } else if(discountArr[k].amount <= coupons) {
                                    this.$data.currDiscount.push(discountArr[k]);
                                    this.$data.discountAmount += this.calcDiscountAmount(discountArr[k]);
                                    this.removeLesserDiscount(discountArr[k]);
                                }
                            } else if (this.totalForTreatment(discountArr[k].treatment_id) > discountArr[k].amount){
                                this.$data.currDiscount.push(discountArr[k]);
                                this.$data.discountAmount += this.calcDiscountAmount(discountArr[k]);
                                this.removeLesserDiscount(discountArr[k]);
                            }
                        }
                    }
                }
                this.updatePrice();
            }
        }
    },
    methods: {
        totalForTreatment (treatment_id) {
            let treatmentTotal = 0;

            for (let j = 0; j < this.$data.cart.length; j++) {
                if (this.$data.cart[j].id == treatment_id) {
                    let vatInDecimals = this.$data.cart[j].vat / 100;
                    let fullPrice = this.$data.cart[j].prices[0].full_price;
                    let totalIncVat = fullPrice * (1 + vatInDecimals) * this.$data.cart[j].quantity ;
                    treatmentTotal += totalIncVat;
                }
            }

            return treatmentTotal;
        },
        calcDiscountAmount (arr) {
            if (arr.is_percentage && !arr.is_sum) {
                let treatment = this.$data.treatmentList.filter(function (item) {
                    return item.id == arr.treatment_id;
                });

                let treatmentVat = treatment[0].vat / 100;
                let fullPriceIncVat = treatment[0].prices[0].full_price * (1 + treatmentVat);
                return this.round2Digits(fullPriceIncVat * arr.amount * (arr.discount_amount / 100));
            } else if (!arr.is_percentage && arr.is_sum) {
                return arr.discount_amount;
            }

            return 0;
        },
        getTreatmentWithId(treatment_id) {
            let treatment = this.$data.treatmentList.filter(function (item) {
                return item.id == treatment_id;
            });

            return treatment[0];
        },
        calculateDiscountSize(discount) {
            let treatment = this.getTreatmentWithId(discount.treatment_id);
            if (discount.is_sum) {
                return discount.discount_amount;
            } else {
                let discountPercentageInDecimals = discount.discount_amount / 100;
                let discountedCoupons = discount.amount;
                let treatmentFullPrice = treatment.prices[0].full_price;
                let vatInDecimals = treatment.vat / 100;
                let totalCost = discountedCoupons * treatmentFullPrice * (1 + vatInDecimals);
                return totalCost * discountPercentageInDecimals;
            }
        },
        removeLesserDiscount(discount) {
            for (let i = 0; i < this.$data.currDiscount.length; i++) {
                if (this.$data.currDiscount[i].treatment_id == discount.treatment_id && this.$data.currDiscount[i].id !== discount.id) {
                    if (this.calculateDiscountSize(this.$data.currDiscount[i]) < this.calculateDiscountSize(discount)) {
                        this.$data.discountAmount -= this.calcDiscountAmount(this.$data.currDiscount[i]);
                        this.$data.currDiscount = this.$data.currDiscount.filter(o => o.id !== this.$data.currDiscount[i].id);
                    } else if (this.calculateDiscountSize(this.$data.currDiscount[i]) >= this.calculateDiscountSize(discount)) {
                        this.$data.discountAmount -= this.calcDiscountAmount(discount);
                        this.$data.currDiscount = this.$data.currDiscount.filter(o => o.id !== discount.id);
                    }
                }
            }
        },
        updatePrice() {
            this.removeSum();
            for (let i = 0; i < this.cart.length; i++) {
                let productVat = this.cart[i].vat / 100;
                let fullPriceNoVat = this.cart[i].quantity * (this.subventions_left ? (this.cart[i].prices[0].subv_price / (1 + productVat)) : this.cart[i].prices[0].full_price);
                let totalVat = fullPriceNoVat * productVat;

                this.cartVatTotal = this.round2Digits(this.cartVatTotal + totalVat);
                this.cartSubTotal = this.round2Digits(this.cartSubTotal + fullPriceNoVat);
            }
            this.cartTotal = this.round2Digits(this.cartSubTotal + this.cartVatTotal);
        },
        discountExists(arr) {
            let discountExists = this.$data.currDiscount.filter(function (item) {
                return item.id == arr.id && item.amount == arr.amount;
            });
            return discountExists.length > 0;
        },
        clearDiscount() {
            this.$data.currDiscount = [];
            this.$data.freeCoupons = [];
        },
        getDiscountType(discount) {
            let type = ' kupong på köpet.';
            if(discount.discount_amount > 1) {
                type = ' kuponger på köpet.';
            }
            if(discount.is_percentage) {
                type = '% rabatt.';
            } else if (discount.is_sum) {
                type = 'kr rabatt.';
            }
            return type;
        },
        activeDiscount(discount) {
            for(let i = 0; i < this.$data.currDiscount.length; i++)
            {
                if(discount === this.$data.currDiscount[i]) {
                    return true;
                }
            }
            return false;
        },
        removeSum: function () {
            this.cartSubTotal = 0;
            this.cartVatTotal = 0;
            this.cartTotal = 0;
        }
    }
}
